<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain competitions">
                    <h5 class="account__section-title">Konkursy:</h5>

                    <div class="competitions__list">
                        <WbBox v-for="(item, index) in competitionsList.items" :key="index" :data="item" class="competitions__item"></WbBox>
                    </div>
                </div>
            </div>
        </div>
        
        <Pagination 
            v-if="isPagination"
            :name="name"
            :itemsPage="itemsPage"
            :itemsPerPage="itemsPerPage" 
            :itemsTotalCount="totalCount">
        </Pagination>
    </div>
</template>

<script>
import axios from "axios";
import AccountSideMenu from "./AccountSideMenu.vue";
import WbBox from "../boxes/WbBox.vue";
import Pagination from "../elements/Pagination.vue";

export default {
    name: "AccountCompetitions",
    components: {
        AccountSideMenu,
        Pagination,
        WbBox
    },
    data() {
        return {
            COMPETITIONS_LIST: '/api/krainaabc/contest/list?device=www',
            competitionsList: [],
            itemsPerPage: 5
        };
    },
    watch: {
        '$route.path': {
            handler: function() {
                this.getCompetitionsList()
            },
            deep: true,
            immediate: true
        }
    },    
    computed: {
        path() {
            return this.$route.path;
        },
        isPagination() {
            if(this.competitionsList.total_count && this.competitionsList.total_count > this.itemsPerPage) {
                return true;
            } 
            return false;
        },
        name() {
            if(this.$route && this.$route.name) {
                return this.$route.name
            }
            return null;
        },
        itemsPage() {
            if(this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            return 1;
        },
        totalCount() {
            if(this.competitionsList && this.competitionsList.total_count) {
                return this.competitionsList.total_count;
            } 
            return null;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        getCompetitionsList() {
            let endpoint = `${this.COMPETITIONS_LIST}&limit=${this.itemsPerPage}&page=${this.itemsPage}`;

            axios.get(endpoint).then((response) => {
                if (response.status === 200) {
                    if(response.data.data) {
                        this.competitionsList = response.data.data;
                    }
                }
            });
        }
    },
    mounted() {
        this.getCompetitionsList();

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        ); 
    }
};
</script>